import update from 'immutability-helper';
import { sortBy } from 'lodash';
import cache from '../cache/cache';

import {
  RESET,
  SET_FILTERS,
  SELECT_FILTER_IN_UI,
  WBS_FILTER_SELECTION,
  CLEAR_FILTERS,
  RESET_CLEAR_DATES_FLAG,
  SET_SEARCH_VALUE,
} from '../actions/actions.types';

let schema = {
  filters: [],
  searchValue: '',
};
let resetSchema = JSON.stringify(schema);

export default function Filters(state = schema, action) {
  switch (action.type) {
    case RESET:
      return JSON.parse(resetSchema);
    case SET_FILTERS:
      //console.log("SET_FILTERS", action)
      return update(state, {
        filters: { $set: action.data },
      });
    case WBS_FILTER_SELECTION:
      return state;
    case SELECT_FILTER_IN_UI:
      let selected;
      let filters = sortBy(state.filters, 'sortOrder');
      const selectedKey = filters[action.parentIndex].key;
      let childIndex = action.childIndex;

      let originalParentIndex;

      for (let i = 0; i < state.filters.length; i++) {
        if (state.filters[i].key === selectedKey) {
          originalParentIndex = i;
        }
      }

      // the date filter doesn't have a child index to set selected on so it passes -1
      if (childIndex > -1) {
        let filter =
          state.filters[originalParentIndex].items[action.childIndex];

        if (filter.selected) {
          selected = false;
        } else {
          selected = true;
        }

        return update(state, {
          filters: {
            [originalParentIndex]: {
              items: {
                [childIndex]: {
                  selected: {
                    $set: selected,
                  },
                },
              },
            },
          },
        });
      }
      // add an item to the dates filter with a selected property. This is need to show the selected indicator in th parent toggle
      let dateFilter = state.filters[originalParentIndex];
      dateFilter.items.push({ selected: true });
      selected = true;
      childIndex = 0;

      let fromDate = action.dateValues.dateRaisedFrom;
      let toDate = action.dateValues.dateRaisedTo;

      // the date filter is one object, yet for the API it has 2 objects. Need to update both on the state object for the API
      return update(state, {
        filters: {
          [originalParentIndex]: {
            value: {
              $set: fromDate,
            },
            items: {
              [childIndex]: {
                selected: {
                  $set: selected,
                },
              },
            },
            clear: {
              $set: false,
            },
          },
          [originalParentIndex + 1]: {
            value: {
              $set: toDate,
            },
            clear: {
              $set: false,
            },
          },
        },
      });
    case CLEAR_FILTERS:
      //console.log('CLEAR_FILTERS...')
      let clearedFilters = JSON.parse(JSON.stringify(state.filters));

      for (let filter of clearedFilters) {
        switch (filter.key) {
          case 'date_raised_from':
          case 'date_raised_to':
            filter.value = '';
            filter.clear = true;
            break;
          case 'wbs_item_ids':
            filter.items.forEach(item => {
              item.selected = false;
              item.hasSelectedChildren = false;
            });
            break;
          default:
            for (let item of filter.items) {
              item.selected = false;
            }
            break;
        }
      }

      cache.addToCache('selected_wbs_filters', []);
      cache.addToCache('selected_custom_filters', []);

      return update(state, {
        filters: { $set: clearedFilters },
      });
    case RESET_CLEAR_DATES_FLAG: {
      let filtersState = JSON.parse(JSON.stringify(state));

      for (let filter of filtersState.filters) {
        if (
          filter.key === 'date_raised_from' ||
          filter.key === 'date_raised_to'
        ) {
          filter.clear = false;
        }
      }

      return update(state, {
        $set: filtersState,
      });
    }
    case SET_SEARCH_VALUE:
      cache.addToCache('search_value', action.val);
      return update(state, {
        searchValue: { $set: action.val },
      });
    default:
      return state;
  }
}
